/**
 * useTranslation 훅
 * 
 * 사용법:
 * import { useTranslation } from '../i18n/useTranslation';
 * 
 * function MyComponent() {
 *   const { t, lang, setLang } = useTranslation();
 *   return <div>{t('calendar.today')}</div>;
 * }
 */

import { useContext, useCallback, useMemo } from 'react';
import { UserContext } from '../contexts/UserContext';
import { t as translate, LANGUAGES, DEFAULT_LANGUAGE } from './index';

/**
 * 다국어 훅
 * @returns {{ t: Function, lang: string, languages: Object }}
 */
export const useTranslation = () => {
    const { userInfo } = useContext(UserContext) || {};
    const lang = userInfo?.preferred_language || DEFAULT_LANGUAGE;

    /**
     * 번역 함수 (메모이제이션)
     */
    const t = useCallback((key, params = {}) => {
        return translate(key, lang, params);
    }, [lang]);

    /**
     * 번역 객체 직접 접근용 (성능 최적화가 필요한 경우)
     */
    const translations = useMemo(() => {
        const cache = {};
        return new Proxy(cache, {
            get: (target, prop) => {
                if (!(prop in target)) {
                    target[prop] = translate(prop, lang);
                }
                return target[prop];
            }
        });
    }, [lang]);

    return {
        t,
        lang,
        languages: LANGUAGES,
        translations
    };
};

export default useTranslation;
